export function initDialogDrag(el) {
  if (!el) return;

  const dragDom = el.querySelector('.el-dialog');
  const dialogHeaderEl = el.querySelector('.el-dialog__header');
  const dialogBodyEl = el.querySelector('.el-dialog__body');
  const dialogFooterEl = el.querySelector('.el-dialog__footer');
  
  if (!dragDom || !dialogHeaderEl) return;

  // ========== 全弹窗统一鼠标样式：全部变成 move ==========
  const allDragAreas = [dialogHeaderEl];
  if (dialogBodyEl) allDragAreas.push(dialogBodyEl);
  if (dialogFooterEl) allDragAreas.push(dialogFooterEl);

  allDragAreas.forEach(el => {
    el.style.cursor = 'move';          // 统一移动手势
    el.style.userSelect = 'none';     // 禁止选中文字
  });

  // 渲染完毕后居中
  setTimeout(() => {
    dragDom.style.margin = '0';
    dragDom.style.position = 'absolute';
    dragDom.style.left = '50%';
    dragDom.style.top = '50%';
    dragDom.style.transform = 'translate(-50%, -50%)';
  }, 0);

  // 全弹窗拖拽
  dragDom.onmousedown = (e) => {
    // 排除所有不能拖拽的元素
    if (
      e.target.closest('.el-dialog__headerbtn') ||
      e.target.closest('.el-upload') ||
      e.target.closest('button') ||
      e.target.closest('input') ||
      e.target.closest('textarea') ||
      e.target.closest('.el-select') ||
      e.target.closest('.el-radio') ||
      e.target.closest('.el-checkbox') ||
      e.target.closest('.el-date-editor') ||
      e.target.closest('.el-cascader') ||
      e.target.closest('.el-switch')
    ) {
      return;
    }

    e.preventDefault();

    // 获取真实位置
    const rect = dragDom.getBoundingClientRect();
    const currentLeft = rect.left;
    const currentTop = rect.top;

    // 父级偏移计算
    let parentOffsetX = 0;
    let parentOffsetY = 0;
    let parent = dragDom.offsetParent;
    while (parent && parent !== document.body && parent !== document.documentElement) {
      parentOffsetX += parent.offsetLeft;
      parentOffsetY += parent.offsetTop;
      parent = parent.offsetParent;
    }

    // 切换为纯 left/top 定位
    dragDom.style.transform = 'none';
    dragDom.style.left = currentLeft - parentOffsetX + 'px';
    dragDom.style.top = currentTop - parentOffsetY + 'px';

    // 记录起点
    const startX = e.clientX;
    const startY = e.clientY;
    const baseLeft = parseFloat(dragDom.style.left);
    const baseTop = parseFloat(dragDom.style.top);

    // 移动
    const onMousemove = (ev) => {
      const dx = ev.clientX - startX;
      const dy = ev.clientY - startY;
      dragDom.style.left = baseLeft + dx + 'px';
      dragDom.style.top = baseTop + dy + 'px';
    };

    // 抬起
    const onMouseup = () => {
      document.removeEventListener('mousemove', onMousemove);
      document.removeEventListener('mouseup', onMouseup);
    };

    document.addEventListener('mousemove', onMousemove);
    document.addEventListener('mouseup', onMouseup);
  };
}